export default "__VITE_ASSET__bpa0ww_i__"